import { render, staticRenderFns } from "./duoDynamicFormMobile.vue?vue&type=template&id=73a90b0e&scoped=true&"
import script from "./duoDynamicFormMobile.vue?vue&type=script&lang=js&"
export * from "./duoDynamicFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoDynamicFormMobile.vue?vue&type=style&index=0&id=73a90b0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a90b0e",
  null
  
)

export default component.exports